import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="17168" id="hero-lead-capture" className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-[hsl(220_45%_8%)] text-foreground" ref={ref}>
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/annapolis_blue_hour_home.png" alt="Institutional real estate investment landmark" className="w-full h-full object-cover opacity-20" />
        {}
        <div className="absolute inset-0 bg-[hsl(220_45%_8%)]/60 bg-gradient-to-b from-[hsl(220_45%_8%)]/40 to-[hsl(220_45%_8%)]/90" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 max-w-[80rem] flex flex-col items-center text-center">
        <div className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h1 className="font-default font-extrabold text-[hsl(0_0%_98%)] text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[1.1] mb-6 drop-shadow-2xl">
            Secure Your Future With <br className="hidden md:block" />
            <span className="text-primary">10% Annual Yield</span>
          </h1>

          <p className="font-sans font-light text-[hsl(215_20%_65%)] text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed drop-shadow-sm">
            Institutional-grade real estate investments backed by 10-year security and 
            tangible assets in prime global locations. Precision growth for your wealth.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full">
            {}
            <Button asChild className="bg-gradient-to-r from-primary to-[hsl(43_60%_45%)] hover:opacity-90 text-primary-foreground font-bold text-base px-8 py-6 h-auto rounded-xl transition-transform duration-200 hover:scale-105 shadow-[0_0_20px_rgba(212,175,55,0.3)] border-0">
              
            </Button>

            {}
            <Button asChild variant="outline" className="bg-transparent border border-[hsl(215_20%_45%)] text-[hsl(0_0%_98%)] hover:bg-white/5 hover:border-primary hover:text-primary font-medium text-base px-8 py-6 h-auto rounded-xl transition-all duration-200 backdrop-blur-sm">
              <Link to="/ContactPage">
                <Phone className="mr-2 w-5 h-5" />
                Speak with an Advisor
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}